import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';
import { useAppSelector } from 'src/store/reducers';
import { getQueryParams } from 'src/util';

import type { HNSkjemaFrontend } from 'src/types/Resources';

export const useGetSubmitButtonText = (): string | undefined => {
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const isSavedInDokumenter = useAppSelector(state => state.refero.ui.isSavedInDokumenter);
  const harEndepunkt = useAppSelector(state => state.refero.ui.harEndepunkt);
  const harGuidanceAction = useAppSelector(state => state.refero.ui.harGuidanceAction);

  if (getQueryParams().has('redirect') || (!harEndepunkt && harGuidanceAction)) {
    return resources?.formProceed;
  }

  if (getQueryParams().has('taskId')) {
    return resources?.formSend;
  }

  return isSavedInDokumenter ? resources?.formFinish : resources?.formSend;
};
